import React from "react";
import { ClientDialogServiceContext } from "./dialog-provider";

export const useClientDialog = () => React.useContext(ClientDialogServiceContext);
